import { useIsFocused } from '@react-navigation/native';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useAuth } from '../../../context/Auth';
import Card from '../../../components/Card';
import DataTableContainer from '../../../components/DataTableContainer';
import { dispatchService } from '../../../services/central-api/dispatch';
import { translate } from '../../../services/translate';
import { applyMask } from '../../../components/helpers/documents';
import MyDataTable from '../../../components/MyDataTable';
import moment from 'moment';

interface Props {
    unitId: number;
}

export default function UnitFormActivitiesAndServices({ unitId }: Props) {
    const { user: authenticatedUser } = useAuth();

    const isFocused = useIsFocused();
    const queryResult = useQuery({
        queryKey: ['getActivityAndServicesForUnit', unitId,],
        queryFn: () => dispatchService.getActivitiesAndServicesForUnit(unitId!),
        enabled: !!authenticatedUser && !!unitId && isFocused,
    });

    const isEnabled = !!authenticatedUser;
    const isLoading = isEnabled && queryResult.isFetching;
    const { data } = queryResult;

    return (
        <Card>
            <DataTableContainer
                dataTable={<MyDataTable

                    columns={[
                        {
                            name: 'ID',
                            cell: row => data ? data.findIndex(item => item.id === row.id) + 1 : '',
                            grow: 0,
                        },
                        {
                            name: translate('indicator'),
                            selector: row => row.indicator.code,
                            wrap: true,
                        },
                        {
                            name: translate('cep'),
                            selector: row => applyMask(row.cep, 'cep'),
                            wrap: true,
                        },
                        {
                            name: translate('address'),
                            selector: row => row.address,
                        },
                        {
                            name: translate('number'),
                            selector: row => row.number,
                            grow: 0,
                        },
                        {
                            name: translate('startTime'),
                            selector: row => moment(row.startDate).format('DD/MM/YYYY HH:mm'),
                        },
                        {
                            name: translate('endTime'),
                            selector: row => moment(row.endDate).format('DD/MM/YYYY HH:mm'),
                        },
                        {
                            name: translate('actions'),
                            selector: row => row.actionsQty,
                        },
                        {
                            name: translate('audience'),
                            selector: row => row.publicQty,
                        },
                        {
                            name: translate('document'),
                            selector: row => row.documentNumber,
                        },
                    ]}
                    data={data ?? []}
                    progressPending={isLoading}
                />}
            />
        </Card>
    );
}
